export const TITLE_BUTTONS = {
  CANCEL: "cancel",
  FINISH: "finish",
  DELETE: "delete",
  EDIT: "edit",
  CREATE_AD: "create ad",
  CREATE_GOVERNING_BODY: "create governing body",
  CREATE_VENUE: "create venue",
  CREATE_TEAM: "create team",
  CREATE_QUALIFYING_SCORE: "create qualifying score",
  COPY_TO_NEW_DATES: "copy to new dates",
  LOGIN: "Log In",
  CHOOSE_FILE: "Choose file",
  SAVE: "save",
  CREATE_FROM_LINK: "create from link",
};

export const PAGES_TITLES = {
  ADS: "Advertisements",
  GOVERNING_BODIES: "Governing bodies",
  TEAMS: "Teams",
  VENUES: "Venues",
  USER_MANAGEMENT: "User management",
  ADMINISTRATION: "Administration",
  QUALIFYING_SCORES: "Qualifying scores",
  MESSAGE_TEMPLATES: "Message templates",
  TOOLS: "Tools",
  RULES: "Rules",
};

export const TITLES = {
  DIVE_LIVE: "Dive Live",
  ADMIN_PANEL: "Administration panel",
  CREATE_TEAM: "Create a new team",
  CREATE_VENUE: "Venue",
  DELETE_MODAL: "Do you want to delete?",
  EDIT_TEAM: "Edit selected team",
  CREATE_AD: "Create a new advertisement",
  EDIT_AD: "Edit selected advertisement",
  CREATE_GOVERNING_BODY: "Create a new governing body",
  EDIT_GOVERNING_BODY: "Edit selected governing body",
  CREATE_QUALIFYING_SCORE: "Create qualifying score",
  EDIT_QUALIFYING_SCORE: "Edit qualifying score",
  COPY_QUALIFYING_SCORES: "Copy qualifying scores to new dates",
  BULK_TEMPLATE_QUALIFYING_SCORES: "Set message template",
  EDIT_SORT: "Edit sort",
  CREATE_TEAM_FROM_LINK: "Create a team from a Google Maps link",
  CREATE_VENUE_FROM_LINK: "Create a venue from a Google Maps link",
};

export const ALERT_TEXT = {
  LOGIN: "Incorrect username or password",
  SESSION_EXPIRED: "Your session has expired. Please log in again.",
  BAD_REQUEST: "The request has been failed",
  SUCCESS_UPDATE_TEAM: "The team updated successfully",
  SUCCESS_DELETE_TEAM: "The team removed successfully",
  SUCCESS_CREATE_TEAM: "The team created successfully",
  SUCCESS_UPDATE_VENUE: "The venue updated successfully",
  SUCCESS_DELETE_VENUE: "The venue removed successfully",
  SUCCESS_CREATE_VENUE: "The venue created successfully",
  BAD_FILE_FORMAT: "The format of selected file is bad",
  SUCCESS_UPDATE_AD: "The advertisement updated successfully",
  SUCCESS_DELETE_AD: "The advertisement removed successfully",
  SUCCESS_CREATE_AD: "The advertisement created successfully",
  SUCCESS_UPDATE_GOVERNING_BODY: "The governing body updated successfully",
  SUCCESS_DELETE_GOVERNING_BODY: "The governing body removed successfully",
  SUCCESS_CREATE_GOVERNING_BODY: "The governing body created successfully",
  SUCCESS_UPDATE_QUALIFYING_SCORE: "Qualifying score updated successfully",
  SUCCESS_DELETE_QUALIFYING_SCORE: "Qualifying score removed successfully",
  SUCCESS_CREATE_QUALIFYING_SCORE: "Qualifying score created successfully",
  SUCCESS_CLONE_QUALIFYING_SCORES: "Qualifying scores copied",
  FORBIDDEN_QUALIFYING_SCORES:
    "You don't have permission to maintain qualifying scores for this governing body.",
  FORBIDDEN_MAPS_AUTOFILL:
    "Creating from a Google Maps link requires system administrator access.",
  MAPS_RESOLVE_FAILED: "Could not read that Google Maps link",
  MAPS_LOGO_IMPORT_FAILED:
    "Could not import that logo. You can still upload one manually.",
  MAPS_VENUE_CREATED_TEAM_PENDING:
    "Venue created. Review the team details and submit to finish.",
  MAPS_VENUE_LINK_FAILED:
    "The venue was created but could not be linked automatically — add it in the Venues field.",
};

// Non-fatal hints returned by POST admin/maps/resolve. Anything not listed here
// is shown verbatim so a new backend warning is never silently swallowed.
export const MAPS_WARNING_TEXT = {
  no_phone_found: "Google had no phone number for this place.",
  timezone_not_determined:
    "Timezone could not be determined — please choose one before saving.",
  no_logo_candidate: "No logo found. Upload one manually if you need it.",
  logo_search_unavailable:
    "Logo lookup is unavailable. Upload one manually if you need it.",
  // Raised by the frontend, not the backend: see utils/mapsAutofill.js
  timezone_unsupported:
    "Google returned a timezone this form doesn't offer — please choose one before saving.",
  logo_import_failed:
    "The logo could not be imported. Upload one manually if you need it.",
};
